"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLOSSOM_API_RESPONSE_EVENT = exports.BLOSSOM_API_EVENT = void 0;
exports.BLOSSOM_API_EVENT = 'blossom-api';
exports.BLOSSOM_API_RESPONSE_EVENT = 'blossom-api-response';
